import { render, staticRenderFns } from "./InvestRequests.vue?vue&type=template&id=06c2d0b8&"
import script from "./InvestRequests.vue?vue&type=script&lang=js&"
export * from "./InvestRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports